import { render, staticRenderFns } from "./PopupChangePassword.vue?vue&type=template&id=676fa4e3"
import script from "./PopupChangePassword.vue?vue&type=script&lang=ts"
export * from "./PopupChangePassword.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports